import React, { useState } from "react"

import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"
import InputsWithoutValidate from "Components/UI/Molecules/InputsWithoutValidate"
import { Add } from "@material-ui/icons"

import File from "./File"
import { Checkbox, Button } from "@material-ui/core"
import BasicTable from "Components/UI/Atoms/BasicTable"
import SetState from "Components/Hooks/SetState"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import { interfaces } from "service/interfaces"
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers"
import DateFnsUtils from "@date-io/date-fns"
import { es } from "date-fns/locale"

const Extra = (props) => {
  const {
    open,
    handleclose,
    setInitValues,
    initValues,
    selectedItem,
    setSelectedItem,
  } = props
  const [openModal, setOpenModal] = useState(false)

  const [tab, setTab] = useState(0)
  const [newItem, setNewItem] = useState({
    calidad: null,
    fotos: [],
    empresa: selectedItem?.empresa,
    id: selectedItem?.id,
    checked: true,
    update_estacion_cero: selectedItem?.update_estacion_cero,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [originalSelectedItem, setOriginalSelectedItem] = useState(null)
  const [originalInitValues, setOriginalInitValues] = useState(null)
  const [selectedRow, setSelectedRow] = useState(null)
  const [hasChanged, setHasChanged] = useState(false)

  const {
    setOpen: setOpenPaymentDetail,
    state: paymentDetail,
    setClose: setClosePaymentDetail,
  } = SetState()

  const handleOpenModal = () => {
    setNewItem({
      calidad: null,
      fotos: [],
      empresa: selectedItem?.empresa,
      id: selectedItem?.id,
      checked: true,
      estado: selectedItem?.estado,
      update_estacion_cero: selectedItem?.update_estacion_cero,
    })
    setOpenModal(true)
  }

  const createDismissableSnackbar = useCustomSnackbar()

  React.useEffect(() => {
    if (open && selectedItem) {
      setOriginalSelectedItem(JSON.parse(JSON.stringify(selectedItem)))
      setOriginalInitValues(JSON.parse(JSON.stringify(initValues)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const horizontalTabs = [
    {
      id: 0,
      title: "1",
      color: "primary",
    },
    {
      id: 1,
      title: "2",
      color: "primary",
    },
    {
      id: 2,
      title: "3",
      color: "primary",
    },
  ]

  async function handleSubmit() {
    handleclose()
  }

  function handlePrev() {
    if (tab !== 0) {
      setTab(tab - 1)
    } else {
      if (originalSelectedItem && originalInitValues) {
        setSelectedItem(originalSelectedItem)
        setInitValues(originalInitValues)
      }
      handleclose()
    }
  }

  const handleAddNewItem = () => {
    if (!newItem.calidad) return

    const itemToAdd = {
      ...newItem,
      checked: true,
      update_estacion_cero: new Date(),
    }

    setSelectedItem((prev) => ({
      ...prev,
      items: [...(prev.items || []), itemToAdd],
    }))

    setInitValues((prev) => ({
      ...prev,
      products: prev.products.map((prod) =>
        prod.id === selectedItem.id
          ? { ...prod, items: [...(prod.items || []), itemToAdd] }
          : prod
      ),
    }))
    setOpenModal(false)
  }

  const onClickRow = (row) => {
    const item = selectedItem.items[row.index]

    if (item && compare(item)) {
      return
    }

    setSelectedRow({ ...item, index: row.index })
    setHasChanged(false)
    setOpenPaymentDetail(true)
  }

  const handleChangeEdit = (name, value) => {
    setHasChanged(true)

    if (name === "calidad") {
      setSelectedRow((prev) => ({
        ...prev,
        [name]: value,
        update_estacion_cero: new Date(),
      }))
    } else {
      setSelectedRow((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
  }

  const fieldCalidad = [
    {
      class: "autocomplete",
      label: "Calidad",
      name: "calidad",
      options: initValues.calidades,
      optionLabel: `options["nombre"]`,
      optionValue: "id",
      onChange: (e) => setNewItem((prev) => ({ ...prev, calidad: e.id })),
      xs: 12,
      sm: 12,
    },
    {
      class: "custom",
      component: (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <KeyboardDatePicker
            key="update_estacion_cero"
            autoOk
            variant="inline"
            inputVariant="outlined"
            PopoverProps={{ style: { ...{ left: "40px" } } }}
            fullWidth
            disabled={true}
            name="update_estacion_cero"
            label="Fecha de revisión"
            format="dd/MM/yyyy"
            value={selectedItem.update_estacion_cero || new Date()}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </MuiPickersUtilsProvider>
      ),
      sm: 12,
      xs: 12,
    },
  ]

  const fieldCalidadEdit = [
    {
      class: "autocomplete",
      label: "Calidad",
      name: "calidad",
      options: initValues.calidades,
      value: selectedRow?.calidad,
      optionLabel: `options["nombre"]`,
      optionValue: "id",
      onChange: (e) => handleChangeEdit("calidad", e.id),
      xs: 12,
      sm: 12,
    },
    {
      class: "custom",
      component: (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <KeyboardDatePicker
            key="update_estacion_cero"
            autoOk
            variant="inline"
            inputVariant="outlined"
            PopoverProps={{ style: { ...{ left: "40px" } } }}
            fullWidth
            onChange={(e) => {
              handleChangeEdit("update_estacion_cero", e)
            }}
            name="update_estacion_cero"
            label="Fecha de revisión"
            format="dd/MM/yyyy"
            value={selectedRow?.update_estacion_cero || new Date()}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </MuiPickersUtilsProvider>
      ),
      sm: 12,
      xs: 12,
    },
  ]

  const getNewPhotos = (initValues, selectedRow) => {
    const originalProduct = initValues.products.find(
      (p) => p.id === selectedRow.id
    )
    if (!originalProduct) return []

    const originalItem = originalProduct.itemsOriginal?.find(
      (item) => item.stock_id === selectedRow.stock_id
    )

    if (!originalItem) return selectedRow.fotos || []

    const originalPhotos = originalItem.fotos || []
    const currentPhotos = selectedRow.fotos || []

    return currentPhotos.filter((photo) => !originalPhotos.includes(photo))
  }

  const editItem = async () => {
    setIsLoading(true)
    const newPhotos = getNewPhotos(initValues, selectedRow)
    const body = {
      calidad: selectedRow.calidad,
      update_estacion_cero: selectedRow.update_estacion_cero,
      fotos: newPhotos,
    }

    await interfaces.plantStation
      .editItem(selectedRow.stock_id, body)
      .then((res) => {
        createDismissableSnackbar(res.data, { variant: "success" })
        setInitValues((prev) => ({
          ...prev,
          products: prev.products.map((prod) => ({
            ...prod,
            items: prod.items.map((item) =>
              item.stock_id === selectedRow.stock_id
                ? {
                    ...item,
                    calidad: selectedRow.calidad,
                    fotos: selectedRow.fotos,
                    update_estacion_cero: selectedRow.update_estacion_cero,
                  }
                : item
            ),
          })),
        }))

        setSelectedItem((prev) => ({
          ...prev,
          items: prev.items.map((item) =>
            item.stock_id === selectedRow.stock_id
              ? {
                  ...item,
                  calidad: selectedRow.calidad,
                  fotos: selectedRow.fotos,
                  update_estacion_cero: selectedRow.update_estacion_cero,
                }
              : item
          ),
        }))
        setClosePaymentDetail()
        setIsLoading(false)
      })
      .catch((err) => {
        createDismissableSnackbar("Error al actualizar item", {
          variant: "error",
        })
        setIsLoading(false)
      })
  }

  const saveItemLocal = () => {
    setInitValues((prev) => ({
      ...prev,
      products: prev.products.map((prod) => {
        if (prod.id === selectedItem.id) {
          return {
            ...prod,
            items: prod.items.map((item, i) =>
              i === selectedRow.index ? { ...selectedRow } : item
            ),
          }
        }
        return prod
      }),
    }))

    setSelectedItem((prev) => ({
      ...prev,
      items: prev.items.map((item, i) =>
        i === selectedRow.index ? { ...selectedRow } : item
      ),
    }))

    createDismissableSnackbar("Item actualizado correctamente", {
      variant: "success",
    })
    setClosePaymentDetail()
  }

  function compare(item) {
    if (item.estado) {
      const hasColocado =
        item.estado === "Colocado" ||
        item.estado === undefined ||
        item.estado === null

      if (!hasColocado) return true
    }
  }

  return (
    <>
      <DialogComponent
        open={open}
        handleclose={tab === 4 ? null : () => handleclose({ code: "" })}
        tabs={horizontalTabs}
        widthLarge="500px"
        title={`Piezas de ${selectedItem.producto}`}
        maxHeight
        children={
          <div
            style={{ marginTop: "10px", maxHeight: "300px", overflowY: "auto" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                backgroundColor: "white",
                marginBottom: "15px",
                height: "25px",
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation()
                  handleOpenModal()
                }}
                disabled={selectedItem.items.length >= selectedItem.limite}
              >
                <Add />
              </Button>
            </div>

            <BasicTable
              size={"small"}
              stylePaper={{
                width: "100%",
                height: "100%",
                overflowY: "auto",
                marginBottom: "15px",
              }}
              col={[
                { title: "", style: { width: "20%", textAlign: "center" } },
                { title: "Calidad", style: { width: "45%" } },
                { title: "Empresa", style: { width: "35%" } },
                { title: "", style: { display: "none" } },
                { title: "", style: { display: "none" } },
                { title: "", style: { display: "none" } },
              ]}
              rows={selectedItem.items.map((row, index) => {
                const calidadNombre =
                  initValues.calidades.find((c) => c.id === row.calidad)
                    ?.nombre ||
                  row.calidad ||
                  ""
                return {
                  checkbox: (
                    <div onClick={(e) => e.stopPropagation()}>
                      <Checkbox
                        checked={row.checked || false}
                        color="primary"
                        onChange={(e) => {
                          e.stopPropagation()
                          const checked = e.target.checked
                          setInitValues((prev) => ({
                            ...prev,
                            products: prev.products.map((prod) => {
                              if (prod.id === selectedItem.id) {
                                return {
                                  ...prod,
                                  items: prod.items.map((item, i) =>
                                    i === index
                                      ? { ...item, checked: checked }
                                      : item
                                  ),
                                }
                              }
                              return prod
                            }),
                          }))

                          setSelectedItem((prev) => ({
                            ...prev,
                            items: prev.items.map((item, i) =>
                              i === index ? { ...item, checked: checked } : item
                            ),
                          }))
                        }}
                        disabled={compare(row)}
                      />
                    </div>
                  ),
                  calidad: (
                    <div
                      style={{
                        color:
                          row.estado === "Colocado" ||
                          row.estado === undefined ||
                          row.estado === null
                            ? "#000000de"
                            : "#919191de",
                        cursor:
                          row.estado === "Colocado" ||
                          row.estado === undefined ||
                          row.estado === null
                            ? "pointer"
                            : null,
                      }}
                    >
                      {calidadNombre}
                    </div>
                  ),
                  empresa: (
                    <div
                      style={{
                        color:
                          row.estado === "Colocado" ||
                          row.estado === undefined ||
                          row.estado === null
                            ? "#000000de"
                            : "#919191de",
                        cursor:
                          row.estado === "Colocado" ||
                          row.estado === undefined ||
                          row.estado === null
                            ? "pointer"
                            : null,
                      }}
                    >
                      {row.empresa}
                    </div>
                  ),
                  index: index,
                  fotos: row.fotos,
                  stock_id: row.stock_id,
                }
              })}
              onClickRow={onClickRow}
            />
          </div>
        }
        actions={
          <CancelConfirmButtons
            onClickSubmit={handleSubmit}
            onClickCancel={handlePrev}
            submitText={"Confirmar"}
            cancelText={"Cancelar"}
            // disabledSubmit={selected.items}
            // disabledCancel={tab === 5 ? true : false}
          />
        }
      />

      {openModal && (
        <DialogComponent
          open={openModal}
          handleclose={() => setOpenModal(false)}
          title="Agregar item"
          widthLarge="500px"
          children={
            <>
              <InputsWithoutValidate fields={fieldCalidad} spacing={2} />
              <File
                formEdit={newItem}
                dataVeh={initValues}
                setInitValues={setInitValues}
                setFormEdit={setNewItem}
                setHasChanged={setHasChanged}
              />
            </>
          }
          actions={
            <CancelConfirmButtons
              onClickSubmit={handleAddNewItem}
              onClickCancel={() => setOpenModal(false)}
              submitText="Guardar"
              cancelText="Cancelar"
              disabledSubmit={
                (selectedItem.foto_obligatoria === "SI" &&
                  (newItem?.fotos.length === 0 || !newItem?.calidad)) ||
                (selectedItem.foto_obligatoria === "NO" && !newItem?.calidad)
              }
            />
          }
        />
      )}

      <DialogComponent
        open={paymentDetail.open}
        title={"Editar item"}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge={"500px"}
        children={
          selectedRow ? (
            <>
              <InputsWithoutValidate fields={fieldCalidadEdit} spacing={2} />
              <File
                formEdit={selectedRow}
                dataVeh={initValues}
                setInitValues={setInitValues}
                setFormEdit={setSelectedRow}
                setHasChanged={setHasChanged}
              />
            </>
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={
              (selectedItem.foto_obligatoria === "SI" &&
                (selectedRow?.fotos.length === 0 || !selectedRow?.calidad)) ||
              (selectedItem.foto_obligatoria === "NO" &&
                !selectedRow?.calidad) ||
              !hasChanged
            }
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={selectedRow?.stock_id ? editItem : saveItemLocal}
            onClickCancel={setClosePaymentDetail}
          />
        }
      />
    </>
  )
}

export default Extra
